export type OrganizationInfo = {
  id: string
  name: string
  description: string
  imageId: string
  orderNumber: number
  profile: number
}

export type GoalInfo = {
  id: string
  currentAmount: number
  targetAmount: number
  name: string
  title: string
  imageId: string
  description: string
  statsImageId: string
  startDate: string
  endDate: string
}

export type AmountInfo = {
  value: string
  txt: string
  isVoucher?: boolean
  isPaid?: boolean
}

export type RuleInfo = {
  id: string
  isRequired: boolean
  title: string
  description: string
  startDate: string
  endDate: string
}

export type VoucherInfo = {
  id: number
  configId: number
  type: number
  value: number
  startDate: Date
  endDate: Date
  publicationStartDate: Date
  publicationEndDate: Date
  description: string
  descriptionEng: string
  title: string
  titleEng: string
  longDescription: string
  longDescriptionEnd: string
  imageId: string
  minPaymentAmount: number
  maxPaymentAmount?: number
}

export type LocationConfig = {
  locationCode: string
  logoId: string
  backgroundId?: string
}

export enum RequestStatus {
  Idle = 'idle',
  Pending = 'pending',
  Fulfilled = 'fulfilled',
  Rejected = 'rejected',
}

export const fetchStatusIs = (status: RequestStatus) => ({
  idle: status === RequestStatus.Idle,
  pending: status === RequestStatus.Pending,
  fulfilled: status === RequestStatus.Fulfilled,
  rejected: status === RequestStatus.Rejected,
})

export const fetchStatus = (statuses: RequestStatus[]) => {
  return {
    idle: statuses.includes(RequestStatus.Idle),
    pending: statuses.includes(RequestStatus.Pending),
    fulfilled: statuses.includes(RequestStatus.Fulfilled),
    rejected: statuses.includes(RequestStatus.Rejected),
  }
}

export enum PaymentStatus {
  Failed = 1,
  Aborted = 2,
}

export type PaymentInfo = {
  status: PaymentStatus
}
